/* eslint-disable max-len */
import React, { FC } from "react";

type IProps = {
  width?: number;
  height?: number;
};

const SvgComponent: FC<IProps> = ({ width = 24, height = 24 }) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 22 22"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      stroke="#908E8D"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M13.9999 4.0863L17.9999 8.0863M20.1739 5.89832C20.7026 5.36974
    20.9997 4.65279 20.9998 3.90517C20.9999 3.15756 20.703 2.44053 20.1744
     1.91182C19.6459 1.38311 18.9289 1.08603 18.1813 1.08594C17.4337 1.08584
     16.7166 1.38274 16.1879 1.91132L2.84193 15.2603C2.60975 15.4918 2.43805
      15.7769 2.34193 16.0903L1.02093 20.4423C0.99509 20.5288 0.993138 20.6207
       1.01529 20.7082C1.03743 20.7957 1.08285 20.8755 1.14673 20.9393C1.21061
        21.0031 1.29055 21.0484 1.37809 21.0704C1.46563 21.0924 1.55749 21.0903
         1.64393 21.0643L5.99693 19.7443C6.3101 19.6491 6.59511 19.4784 6.82693
         19.2473L20.1739 5.89832Z"
    />
  </svg>
);

export default SvgComponent;
